import useAuth from 'hooks/useAuth';
import { useTenantData } from 'providers/Tenant/TenantDataProvider';

// Flags por tenant (vienen en tenantData de GET /tenants/get-tenant-config).
//   readOnly:     el portal del rol `administrador` queda en solo-lectura
//                 (ocultar botones de crear/editar/borrar; la subida a Carpeta 0
//                 sigue habilitada porque el backend la whitelistea).
//   minvuEnabled: el módulo MINVU (certificaciones, alertas, compliance/semáforo)
//                 está activo para el tenant.
//   isPro:        el tenant tiene plan 'pro'. Las features pro (árbol de
//                 componentes, hallazgos, presupuestos/órdenes/comprobantes,
//                 colecciones, dashboards avanzados) las gatea el backend con
//                 requirePlan('pro'); este flag oculta su UI en plan lite para
//                 no mostrar tabs/listados que reventarían con 403 PLAN_REQUIRED.
//
// El backend es la barrera real (enforceReadOnly + requireMinvu + requirePlan);
// estos flags son para la UX (esconder controles/módulos que no aplican).
export const useTenantFlags = () => {
  const { user } = useAuth();
  const { tenant } = useTenantData();

  const isAdmin = user?.type === 'administrador';
  const readOnlyTenant = tenant?.read_only === true || tenant?.read_only === 1;
  const minvuOff = tenant?.minvu_enabled === false || tenant?.minvu_enabled === 0;
  // Solo se considera lite cuando el plan viene explícitamente como 'lite'. Si
  // el plan aún no cargó (config en vuelo) o es 'pro', se trata como pro para no
  // ocultar features por error en tenants pagos.
  const isPro = tenant?.plan !== 'lite';

  // El portal del cliente en plan lite es de solo-consulta: el administrador
  // queda read-only tanto si el tenant tiene read_only explícito como si el
  // plan es lite. El backend aplica la misma regla (enforceReadOnly.ts).
  const readOnly = isAdmin && (readOnlyTenant || !isPro);

  return {
    readOnly,
    minvuEnabled: !minvuOff,
    isPro,
  };
};

export default useTenantFlags;
